import { handleJSON, stringifyParams } from '@/utils/fetch-utils';
import { headers } from './index';

export const USER_SEARCH_PAGE_SIZE = 15;
const { API_URL } = process.env;

export default {
  endpoints: {
    authenticate: `${API_URL}/token-auth-permissions/`,
    tokenVerify: `${API_URL}/token-verify/`,
    users: id => {
      const baseUrl = `${API_URL}/users`;

      return id ? `${baseUrl}/${id}` : baseUrl;
    },
  },

  tokenAuthentication(token) {
    if (!token) {
      return Promise.reject();
    }

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    };

    return fetch(this.endpoints.tokenVerify, options).then(handleJSON);
  },

  authenticate(username, password) {
    const body = new URLSearchParams();
    body.set('username', username);
    body.set('password', password);

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body,
    };

    return fetch(this.endpoints.authenticate, options).then(handleJSON);
  },

  fetchUserProfile(userId) {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.users(userId);

    return fetch(endpoint, options).then(handleJSON);
  },

  setUserTimeZone({ id, timezone }) {
    const options = {
      method: 'PATCH',
      headers: headers(),
      body: JSON.stringify({ timezone }),
    };
    const endpoint = this.endpoints.users(id);

    return fetch(endpoint, options).then(handleJSON);
  },

  searchUsers(query, signal) {
    const options = {
      method: 'GET',
      headers: headers(),
      signal,
    };
    const params = {
      search: query,
      page: 1,
      page_size: USER_SEARCH_PAGE_SIZE,
    };
    const endpoint = `${this.endpoints.users()}${stringifyParams(params)}`;

    return fetch(endpoint, options).then(handleJSON);
  },

  loadUsersPage(url, signal) {
    const options = {
      method: 'GET',
      headers: headers(),
      signal,
    };

    return fetch(url, options).then(handleJSON);
  },
};
